import { useRef, useEffect } from 'react';
import { isRightClick } from '@reach/utils';
import 'tslib';
import '../../hooks/useDetectInputMethod.js';
import { useId } from '@reach/auto-id';
import '@emotion/react';
import 'lodash.get';
import '@compono/ui-theme';
import 'deepmerge';
import '@emotion/is-prop-valid';
import { CLOSE_TOGGLETIP, OPEN_TOGGLETIP, SET_BUTTON_ID } from '../actions.js';
import { useToggleTipContext } from '../components/ToggleTipProvider.js';

/**
 * useToggleTipButton
 *
 * provide shared functions for ToggleTipButton and ToggleTipIconButton
 * Following popover position design pattern in reach-ui
 * https://github.com/reach/reach-ui/tree/main/packages/popover
 *
 */
var useToggleTipButton = function () {
    var _a = useToggleTipContext(), buttonClickedRef = _a.buttonClickedRef, dispatch = _a.dispatch, _b = _a.state, buttonId = _b.buttonId, isOpen = _b.isOpen;
    var autoId = useId();
    var keyTimer = useRef(0);
    var mouseTimer = useRef(0);
    useEffect(function () {
        return function () {
            keyTimer.current && clearTimeout(keyTimer.current);
            mouseTimer.current && clearTimeout(mouseTimer.current);
        };
    }, []);
    var handleKeyDown = function (event) {
        switch (event.key) {
            case "Enter":
            case " ":
                if (isOpen) {
                    dispatch({ type: CLOSE_TOGGLETIP });
                }
                else {
                    keyTimer.current = setTimeout(function () {
                        dispatch({ type: OPEN_TOGGLETIP });
                    });
                }
                break;
        }
    };
    var handleMouseDown = function (event) {
        if (!isOpen) {
            buttonClickedRef.current = true;
        }
        if (isRightClick(event.nativeEvent)) {
            return;
        }
        else if (isOpen) {
            dispatch({ type: CLOSE_TOGGLETIP });
        }
        else {
            mouseTimer.current = setTimeout(function () {
                dispatch({ type: OPEN_TOGGLETIP });
            });
        }
    };
    var setButtonId = function (id) {
        var newButtonId = id ? id : "toggleTip-button--".concat(autoId);
        if (buttonId !== newButtonId) {
            dispatch({
                type: SET_BUTTON_ID,
                payload: newButtonId,
            });
        }
    };
    return {
        handleKeyDown: handleKeyDown,
        handleMouseDown: handleMouseDown,
        setButtonId: setButtonId,
    };
};

export { useToggleTipButton };
//# sourceMappingURL=useToggleTipButton.js.map
